import React, { useRef, useEffect, useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

import "./Home.css";

import { Autoplay, Pagination, Navigation, EffectFade } from "swiper/modules";
import QRCodeStyling from "qr-code-styling";

export default function Home() {
  const qrWidth = 150;
  const qrHeight = 150;

  const extraQr = useMemo(() => ({
    width: qrWidth,
    height: qrHeight,
    margin: 0,
    dotsOptions: { type: "rounded", color: "rgba(0,0,0,.7)", gradient: null },
    cornersSquareOptions: { type: "rounded", color: "rgba(0,0,0,.7)" },
    cornersDotOptions: { type: "dot", color: "rgba(0,0,0,.7)" },
    backgroundOptions: { color: "transparent" },
  }), []);

  const qrCode2Android = useMemo(() => new QRCodeStyling({
    ...extraQr,
    data: "https://play.google.com/store/apps/details?id=com.dgm.scsoposiciones",
  }), [extraQr]);

  const qrCode2iOS = useMemo(() => new QRCodeStyling({
    ...extraQr,
    data: "https://apps.apple.com/es/app/scs-oposiciones/id6477230871?platform=iphone",
  }), [extraQr]);

  const qrCode3Android = useMemo(() => new QRCodeStyling({
    ...extraQr,
    data: "https://play.google.com/store/apps/details?id=com.cmgesar.meditacion",
  }), [extraQr]);

  const qrCode3iOS = useMemo(() => new QRCodeStyling({
    ...extraQr,
    data: "https://apps.apple.com/es/app/medita-gesar/id6471571375",
  }), [extraQr]);

  const qrCode4Android = useMemo(() => new QRCodeStyling({
    ...extraQr,
    data: "https://play.google.com/store/apps/details?id=com.europared.jotaeme",
  }), [extraQr]);

  const qrContainerRef2Android = useRef(null);
  const qrContainerRef2iOS = useRef(null);
  const qrContainerRef3Android = useRef(null);
  const qrContainerRef3iOS = useRef(null);
  const qrContainerRef4Android = useRef(null);

  useEffect(() => {
    qrContainerRef2Android.current.innerHTML = "";
    qrContainerRef2iOS.current.innerHTML = "";
    qrContainerRef3Android.current.innerHTML = "";
    qrContainerRef3iOS.current.innerHTML = "";
    qrContainerRef4Android.current.innerHTML = "";

    qrCode2Android.append(qrContainerRef2Android.current);
    qrCode2iOS.append(qrContainerRef2iOS.current);
    qrCode3Android.append(qrContainerRef3Android.current);
    qrCode3iOS.append(qrContainerRef3iOS.current);
    qrCode4Android.append(qrContainerRef4Android.current);
  }, [qrCode2Android, qrCode2iOS, qrCode3Android, qrCode3iOS, qrCode4Android]);

  const openUrl = (url) => window.open(url, "_blank");

  return (
    <Swiper
      rewind={true}
      navigation={true}
      effect="fade"
      loop={true}
      style={{ "--swiper-theme-color": "#e04e18" }}
      pagination={{ type: "progressbar", clickable: true }}
      modules={[Autoplay, Pagination, Navigation, EffectFade]}
      className="mySwiper"
      slidesPerView={1}
      spaceBetween={0}
      autoplay={{ delay: 5000, disableOnInteraction: false }}
    >
      <SwiperSlide>
        <div className="slide-inner">
          <div className="slide-image-wrap">
            <img src="/imagenes/imagen2_all.png" alt="SCS Oposiciones" />
          </div>
          <div className="slide-content">
            <span className="slide-badge">Educación · Salud</span>
            <h2>SCS Oposiciones</h2>
            <p>
              Tu aliado perfecto para prepararte de manera efectiva. Accede a
              preguntas tipo test de todos los temarios disponibles para las
              oposiciones del SCS, permitiéndote practicar y evaluar tus
              conocimientos de manera interactiva.
            </p>
            <div className="store-cards">
              <div
                className="store-card"
                onClick={() => openUrl("https://play.google.com/store/apps/details?id=com.dgm.scsoposiciones")}
              >
                <div className="qr" ref={qrContainerRef2Android} />
                <img src="imagenes/logo_android.png" alt="Android" />
              </div>
              <div
                className="store-card"
                onClick={() => openUrl("https://apps.apple.com/es/app/scs-oposiciones/id6477230871?platform=iphone")}
              >
                <div className="qr" ref={qrContainerRef2iOS} />
                <img src="imagenes/logo_ios.png" alt="iOS" />
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide>

      <SwiperSlide>
        <div className="slide-inner">
          <div className="slide-image-wrap">
            <img src="/imagenes/imagen3_all.png" alt="Medita Gesar" />
          </div>
          <div className="slide-content">
            <span className="slide-badge">Bienestar · Meditación</span>
            <h2>Medita Gesar</h2>
            <p>
              Tu guía serena hacia la paz interior y la plenitud espiritual.
              Experimenta sesiones de meditación guiada, adaptadas a tu ritmo
              y necesidades. Personaliza tus sesiones para relajación,
              concentración o bienestar general.
            </p>
            <div className="store-cards">
              <div
                className="store-card"
                onClick={() => openUrl("https://play.google.com/store/apps/details?id=com.cmgesar.meditacion")}
              >
                <div className="qr" ref={qrContainerRef3Android} />
                <img src="imagenes/logo_android.png" alt="Android" />
              </div>
              <div
                className="store-card"
                onClick={() => openUrl("https://apps.apple.com/es/app/medita-gesar/id6471571375")}
              >
                <div className="qr" ref={qrContainerRef3iOS} />
                <img src="imagenes/logo_ios.png" alt="iOS" />
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide>

      <SwiperSlide>
        <div className="slide-inner">
          <div className="slide-image-wrap">
            <img src="/imagenes/imagen4_all.png" alt="Calculadora Interés Compuesto" />
          </div>
          <div className="slide-content">
            <span className="slide-badge">Finanzas · Herramientas</span>
            <h2>Calculadora Interés Compuesto</h2>
            <p>
              Una herramienta financiera esencial que te permite explorar el
              crecimiento exponencial de tus inversiones. Ingresa el capital
              inicial, la tasa de interés y el periodo de tiempo para revelar
              el valor futuro de tu inversión.
            </p>
            <div className="store-cards">
              <div
                className="store-card"
                onClick={() => openUrl("https://play.google.com/store/apps/details?id=com.europared.jotaeme")}
              >
                <div className="qr" ref={qrContainerRef4Android} />
                <img src="imagenes/logo_android.png" alt="Android" />
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
  );
}
